<div class="body_wrap dashboard_body">
  <!-- <div class="sticky-top sticky-offset">
    <div class="top_menu">
      <button mat-button class="d-md-none d-none"><img src="../../assets/images/menu.svg" /></button>
    </div>
  </div> -->
  <div class="dash_base">
    <div class="container" *ngIf="(this.myHomeState.myHomeList$ | async)?.length && address; else noMyHome">
      <div class="row mt-5">
        <div class="col-lg-12">
          <h4>My Home</h4>
          <app-my-home-list (activeHomeChanged)="activeHomeChanged()" [myHomeList]="homeList"></app-my-home-list>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <app-property-overview
            [address]="address"
            [currentValue]="currentValue"
            [propmixValue]="propmixValue"
            [loanBalance]="loanBalance"
            [netEquity]="netEquity"
            [appreciateRatio]="appreciateRatio"
            [purchaseValue]="purchaseValue"
            (currentValueEvent)="currentValueEdited($event)"
            (propmixValueEvent)="propmixValueEdited($event)"
            (purchaseValueEvent)="purchaseValueEdited($event)"
            (mortgageSectionToScroll)="onSectionScrolled($event)"
            (equitySectionToScroll)="equitySectionScrolled($event)"
          >
          </app-property-overview>
        </div>
      </div>

      <div *ngIf="!newMyProperty">
        <div class="row my-4">
          <div class="col-lg-12">
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title><h5 class="mb-0">Your Monthly Costs</h5></mat-panel-title>
              </mat-expansion-panel-header>
              <app-property-monthly-cost></app-property-monthly-cost>
            </mat-expansion-panel>
          </div>
        </div>
        <div class="row my-4">
          <div class="col-lg-12" #mortgageSectionToScroll>
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title
                  ><h5 class="mb-0">Current Mortgage Details</h5>
                  <button mat-flat-button mat-stroked-button (click)="$event.stopPropagation(); openMortgagePopup()">
                    Add Mortgage
                  </button></mat-panel-title
                >
              </mat-expansion-panel-header>
              <app-mortgage-group
                *ngIf="mortgageArray && mortgageArray.length != 0"
                [mortgageList]="mortgageArray"
              ></app-mortgage-group>
            </mat-expansion-panel>
          </div>
        </div>
        <div class="row my-4" *ngIf="mortgageArray && mortgageArray.length != 0">
          <div class="col-lg-12">
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title><h5 class="mb-0">See how you can save on your mortgage</h5></mat-panel-title>
              </mat-expansion-panel-header>
              <mat-tab-group class="savings-tab">
                <mat-tab>
                  <ng-template mat-tab-label> Pay Extra Every Month</ng-template>
                  <div mat-dialog-content>
                    <app-extra-payment class="mortgage-tab" [mortgageList]="mortgageArray"></app-extra-payment>
                  </div>
                </mat-tab>
                <mat-tab>
                  <ng-template mat-tab-label> Refinance </ng-template>
                  <div mat-dialog-content>
                    <app-refinance class="mortgage-tab" [mortgageList]="mortgageArray"></app-refinance>
                  </div>
                </mat-tab>
              </mat-tab-group>
            </mat-expansion-panel>
          </div>
        </div>
        <div class="row my-4 mb-5">
          <div class="col-lg-12" #equitySectionToScroll>
            <!-- <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title><h5 class="mb-0">What can you do with your home equity?</h5></mat-panel-title>
              </mat-expansion-panel-header>
              <app-spend-forecast [propertyValue]="propmixValue || currentValue" [loanBalance]="loanBalance">
              </app-spend-forecast>
            </mat-expansion-panel> -->
          </div>
        </div>
        <br />
      </div>

      <div class="row ml-0 mr-0" *ngIf="newMyProperty">
        <div
          class="col-lg-12 mb-5"
          style="background-color: #fff; padding: 0px 0px; border-radius: 15px; border: 1px solid #e7e7e7"
        >
          <mat-tab-group [(selectedIndex)]="tabIndex" class="mat_tab property_tab">
            <mat-tab
              label="Property Details"
              color="primary"
              class="mat-tab-label-active"
              *ngIf="propertyDetailsEnabled"
            >
              <app-home-property-details [selectedIndexTab]="selectedTabIndex"></app-home-property-details>
              <!-- <app-followed-properties-card-view></app-followed-properties-card-view> -->
            </mat-tab>
            <mat-tab label="Maintenance" *ngIf="maintenanceEnabled">
              <app-maintenance-alerts></app-maintenance-alerts>
            </mat-tab>
            <mat-tab label="Finance" *ngIf="financingEnabled">
              <app-financing
                [appreciateRatio]="appreciateRatio"
                [address]="address"
                [currentValue]="currentValue"
                [propmixValue]="propmixValue"
                [loanBalance]="loanBalance"
                [netEquity]="netEquity"
                [appreciateRatio]="appreciateRatio"
                [purchaseValue]="purchaseValue"
              >
              </app-financing>
            </mat-tab>
            <mat-tab label="Rental Analysis" *ngIf="rentalAnalysisEnabled">
              <mat-panel-title
                ><h5 class="mb-0"></h5>
                <button
                  mat-flat-button
                  class="mt-3 mr-2"
                  style="float: right"
                  color="primary"
                  type="button"
                  (click)="addRental()"
                >
                  Start Rental Analysis
                </button></mat-panel-title
              >
              <ng-container *ngIf="savedDealList.length > 0; else noDeals">
                <div class="row px-4 mb-5">
                  <div class="col-lg-4 col-md-4 col-sm-6 col-12" *ngFor="let deal of savedDealList">
                    <app-rental-deal-analysis-card [savedDealData]="deal"></app-rental-deal-analysis-card>
                  </div>
                </div>
              </ng-container>

              <ng-template #noDeals>
                <div class="notFound text-center no-deals">
                  <img class="img-fluid mb-2" width="50" src="~/../assets/images/notFound.svg" />
                  <h4>No Saved Analysis Available!</h4>
                </div>
              </ng-template>
            </mat-tab>
            <mat-tab label="CMA Reports" *ngIf="appState?.companyInfoValue?.alias !== 'valuetest'">
              <ng-container *ngIf="cmaReports && cmaReports.length > 0; else noReports">
                <div class="row px-4 mb-5">
                  <div class="col-lg-4 col-md-4 col-sm-6 col-12" *ngFor="let reportData of cmaReports">
                    <app-cma-report-card [report]="reportData"></app-cma-report-card>
                  </div>
                </div>
              </ng-container>

              <ng-template #noReports>
                <div class="notFound text-center no-deals">
                  <img class="img-fluid mb-2" width="50" src="~/../assets/images/notFound.svg" />
                  <h4>No Reports Available!</h4>
                </div>
              </ng-template>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
    <ng-template #noMyHome>
      <div class="no-data-placeholder text-center py-4">
        <img src="assets/images/partnerholder.png" width="260px" />
        <h5 class="mb-4">Your home will be listed here</h5>
        <mat-spinner [diameter]="30" *ngIf="isLoading; else addNewHome"></mat-spinner>
        <ng-template #addNewHome>
          <h6 class="mb-3">You can start by adding a new home.</h6>
          <button mat-flat-button color="primary" (click)="openAppPropertyDialog(null)">Add a Property</button>
        </ng-template>
      </div>
    </ng-template>
  </div>
</div>

<div
  class="footer_menu d-block d-md-none"
  *ngIf="(this.myHomeState.myHomeList$ | async)?.length && address && !newMyProperty"
>
  <div class="row px-2">
    <div class="col-lg-9 col-md-9 col-8 myH_name px-2">
      <h5>{{ address.streetAddress }}</h5>
      <span>{{ address.city }}, {{ address.state }},{{ address.zip }}</span>
    </div>
    <div class="col-lg-3 col-md-3 col-4 px-2">
      <!-- <button class="float-right mt-md-2 mt-1" mat-flat-button color="primary" (click)="updateHome()">
        <mat-icon inline="true" class="mr-md-2 mr-0">save</mat-icon><span class="d-none d-md-inline-block">Save</span>
      </button> -->
      <button
        class="close float-right mt-1 d-block d-md-none mr-2"
        (click)="deleteProperty(address.id)"
        mat-flat-button
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
</div>

<app-article-sliding-sheet
  *ngIf="myHomeState.isArticleSheetOpenedValue != null ? true : false"
></app-article-sliding-sheet>

<app-image-gallery
  *ngIf="isGalleryOpen"
  [selectedIndex]="imageGalleryState.imgGalleryCurrentIndex"
  (close)="closeGallery()"
  [isImagesFullView]="true"
></app-image-gallery>
